export default __webpack_public_path__ + "static/image-b-000540c74ce1a3051d68ba83b9bf7380.webp";